import { createAsyncThunk } from '@reduxjs/toolkit';
import { callValidateRutGoldSilver } from '../../services/RutsService';
import { contactBackBff } from '../../../src/config/paths';

export const validateRutGoldSilver = createAsyncThunk(
  'rut/validate/goldsilver',
  async (data) => {
    const response = await callValidateRutGoldSilver(data, contactBackBff);
    return response.data;
  },
);
